import { Link } from 'react-router'
import React from 'react'
import PageHeader from './PageHeader'
import Header from './Header'
import Footer from './Footer'

class Regulation extends React.Component { // eslint-disable-line react/prefer-stateless-function
  render() {
    return (
      <div>
        <Header />
        <div>
          <Link to="/Regulation"><PageHeader title="Regulamento do sistema de indicação" /></Link>
          <div className="container">
            <section className="section">
              <p><strong>1.</strong> O desconto será aplicado na <strong>primeira mensalidade</strong> do indicador, após <br />fechamento da proposta do indicado.</p>
              <p>2. Após indicação realizada, o indicado deverá efetuar a contratação no prazo<br /> máximo de <strong>30 dias.</strong></p>
              <p>3. Será aplicado o percentual de <strong>35% de desconto</strong> em cada parcela, com base na<br /> quantidade de indicações concretizadas. Exemplo:</p>
              <div className="my-4">
                <p style={{ lineHeight: '0.7rem' }}>&bull; Indique 1 = Desconto de 35% em UMA mensalidade</p>
                <p style={{ lineHeight: '0.7rem' }}>&bull; Indique 2 = Desconto de 35% em DUAS mensalidades</p>
                <p style={{ lineHeight: '0.7rem' }}>&bull; Indique 3 = Desconto de 35% em TR&Ecirc;S mensalidades</p>
                <p style={{ lineHeight: '0.7rem' }}>&bull; Indique 4 = Desconto de 35% em QUATRO mensalidades</p>
                <p style={{ lineHeight: '0.7rem' }}>&bull; Indique 5 = Desconto de 35% em CINCO mensalidades</p>
              </div>
              <p>4. O desconto máximo para o indicador é de <strong>R$200,00.</strong></p>
              <p>5. Caso o indicado concretize a compra, será beneficiado com um <strong>desconto de 5%</strong><br />na primeira mensalidade.</p>
              <p>6. O indicado não pode já ter sido indicado por outro cliente Softin.</p>
              <p>7. O indicado não pode ser um cliente Softin.</p>
              <p>8. O indicado não pode ser participante de outra promoção ou campanha de <br />descontos, a exemplo da política de desconto fechada para autorizadas de um<br />determinado fabricante.</p>
              <p>9. Regras válidas para plataforma Gravíttem.</p>
            </section>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

export default Regulation



// WEBPACK FOOTER //
// ./client/components/Regulation.js